import { useStaticQuery, graphql } from 'gatsby';

const infoQuery = () => {
    const data = useStaticQuery(graphql`
        query InfoQuery {
            contentfulInfo {
                phone2
                phone1
                name
                email
                fax
                address
            }
        }
    `);
    return data.contentfulInfo;
};

export default infoQuery;
